var _defs, _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "google-play-badge-logo-svgrepo-com_2_",
    "data-name": "google-play-badge-logo-svgrepo-com (2)",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 171.752,
    height: 50.89,
    viewBox: "0 0 171.752 50.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.908,
    y1: 1.032,
    x2: -0.383,
    y2: 0.36,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.077,
    y1: 0.729,
    x2: -1.307,
    y2: 0.729,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.864,
    y1: -0.023,
    x2: -0.499,
    y2: -1.789,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.186,
    y1: 2.701,
    x2: 0.423,
    y2: 1.909,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_105863",
    "data-name": "Path 105863",
    d: "M165.391,50.89H6.361A6.3,6.3,0,0,1,0,44.528V6.361A6.3,6.3,0,0,1,6.361,0h159.03a6.3,6.3,0,0,1,6.361,6.361V44.528A6.3,6.3,0,0,1,165.391,50.89Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_105864",
    "data-name": "Path 105864",
    d: "M165.391,1.018a5.376,5.376,0,0,1,5.343,5.343V44.528a5.376,5.376,0,0,1-5.343,5.343H6.361a5.376,5.376,0,0,1-5.343-5.343V6.361A5.376,5.376,0,0,1,6.361,1.018h159.03m0-1.018H6.361A6.38,6.38,0,0,0,0,6.361V44.528A6.3,6.3,0,0,0,6.361,50.89h159.03a6.3,6.3,0,0,0,6.361-6.361V6.361A6.38,6.38,0,0,0,165.391,0Z",
    fill: "#a6a6a6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_105865",
    "data-name": "Path 105865",
    d: "M48.988,11.074A3.445,3.445,0,0,1,48.1,13.6a3.921,3.921,0,0,1-6.7-2.782A3.887,3.887,0,0,1,45.321,6.9a3.367,3.367,0,0,1,1.518.379,2.754,2.754,0,0,1,1.138.885l-.632.632a2.358,2.358,0,0,0-2.024-.885A2.516,2.516,0,0,0,43.3,8.8a2.605,2.605,0,0,0-.885,2.15A2.605,2.605,0,0,0,43.3,13.1a3.257,3.257,0,0,0,2.024.885,2.774,2.774,0,0,0,2.15-.885,2.094,2.094,0,0,0,.632-1.518H45.321V10.568h3.668v.506Zm5.818-3.162H51.391v2.4h3.162V11.2H51.391v2.4h3.415v1.012H50.379V7.026h4.426Zm4.174,6.7H57.968v-6.7h-2.15V7.026H61.13v.885H58.98Zm5.818,0V7.026h1.012v7.588Zm5.312,0H69.1v-6.7h-2.15V7.026h5.185v.885h-2.15v6.7ZM82.124,13.6a3.921,3.921,0,0,1-6.7-2.782,3.921,3.921,0,1,1,7.841,0A3.719,3.719,0,0,1,82.124,13.6Zm-4.806-.632a2.985,2.985,0,0,0,2.024.885,2.516,2.516,0,0,0,2.024-.885,3.051,3.051,0,0,0,.885-2.15,2.605,2.605,0,0,0-.885-2.15,2.985,2.985,0,0,0-2.024-.885,2.516,2.516,0,0,0-2.024.885,3.051,3.051,0,0,0-.885,2.15A2.605,2.605,0,0,0,77.318,12.971Zm7.335,1.644V7.026h1.138l3.668,5.944V7.026h1.012v7.588H89.459l-3.921-6.2v6.2h-.885Z",
    transform: "translate(11.396 1.888)",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_105866",
    "data-name": "Path 105866",
    d: "M75.247,23.044a5.321,5.321,0,0,0-5.438,5.438,5.4,5.4,0,0,0,5.438,5.438,5.321,5.321,0,0,0,5.438-5.438A5.247,5.247,0,0,0,75.247,23.044Zm0,8.6a3.139,3.139,0,0,1-3.035-3.288,3.139,3.139,0,0,1,3.035-3.288,3.064,3.064,0,0,1,3.035,3.288A3.139,3.139,0,0,1,75.247,31.644Zm-11.762-8.6a5.321,5.321,0,0,0-5.438,5.438,5.4,5.4,0,0,0,5.438,5.438,5.321,5.321,0,0,0,5.438-5.438A5.247,5.247,0,0,0,63.485,23.044Zm0,8.6a3.139,3.139,0,0,1-3.035-3.288,3.139,3.139,0,0,1,3.035-3.288,3.064,3.064,0,0,1,3.035,3.288A3.139,3.139,0,0,1,63.485,31.644ZM49.447,24.688v2.276h5.438a4.782,4.782,0,0,1-1.265,2.909,5.6,5.6,0,0,1-4.174,1.644A5.888,5.888,0,0,1,43.5,25.447a5.966,5.966,0,0,1,5.944-6.071,6.271,6.271,0,0,1,4.174,1.644l1.644-1.644A8.1,8.1,0,0,0,49.574,17.1,8.531,8.531,0,0,0,41.1,25.447a8.531,8.531,0,0,0,8.474,8.347,7.278,7.278,0,0,0,5.818-2.4,7.613,7.613,0,0,0,2.024-5.312,4.742,4.742,0,0,0-.126-1.391H49.447Zm57.418,1.771a4.914,4.914,0,0,0-4.553-3.415,5.094,5.094,0,0,0-5.059,5.438,5.293,5.293,0,0,0,5.312,5.438,5.188,5.188,0,0,0,4.426-2.4l-1.771-1.265a3.083,3.083,0,0,1-2.656,1.518,2.744,2.744,0,0,1-2.656-1.644l7.209-3.035-.253-.632ZM99.53,28.229a3.072,3.072,0,0,1,2.782-3.162,2.237,2.237,0,0,1,2.024,1.138L99.53,28.229Zm-5.944,5.185h2.4V17.606h-2.4Zm-3.794-9.232a4.164,4.164,0,0,0-2.909-1.265A5.434,5.434,0,0,0,81.7,28.356a5.237,5.237,0,0,0,5.185,5.312A3.631,3.631,0,0,0,89.665,32.4h.126v.759c0,2.024-1.138,3.162-2.909,3.162a2.81,2.81,0,0,1-2.656-1.9l-2.024.885a5.218,5.218,0,0,0,4.806,3.162c2.782,0,5.059-1.644,5.059-5.565V23.3H89.792v.885Zm-2.782,7.462a3.139,3.139,0,0,1-3.035-3.288,3.139,3.139,0,0,1,3.035-3.288,3.043,3.043,0,0,1,2.909,3.288A3.043,3.043,0,0,1,87.009,31.644Zm30.859-14.038h-5.691V33.415h2.4V27.471h3.288a4.939,4.939,0,1,0,0-9.865Zm.126,7.588H114.58V19.756h3.415a2.778,2.778,0,0,1,2.782,2.656,2.894,2.894,0,0,1-2.782,2.782Zm14.544-2.276a4.251,4.251,0,0,0-4.174,2.4l2.15.885a2.234,2.234,0,0,1,2.15-1.138,2.377,2.377,0,0,1,2.529,2.024v.126a5.017,5.017,0,0,0-2.4-.632c-2.276,0-4.553,1.265-4.553,3.541a3.705,3.705,0,0,0,3.921,3.541,3.559,3.559,0,0,0,3.035-1.518h.126v1.265H137.6V27.344a4.786,4.786,0,0,0-5.059-4.427Zm-.253,8.727c-.759,0-1.9-.379-1.9-1.391,0-1.265,1.391-1.644,2.529-1.644a4.891,4.891,0,0,1,2.15.506A2.945,2.945,0,0,1,132.286,31.644Zm13.28-8.347-2.656,6.829h-.126L140,23.3h-2.529l4.174,9.612-2.4,5.312h2.4l6.45-14.924h-2.529ZM124.318,33.415h2.4V17.606h-2.4Z",
    transform: "translate(11.895 4.828)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24390",
    "data-name": "Group 24390",
    transform: "translate(12.647 9.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105867",
    "data-name": "Path 105867",
    d: "M10.506,7.5A2.473,2.473,0,0,0,10,9.271v27.95a2.5,2.5,0,0,0,.632,1.771l.126.126L26.441,23.435v-.253Z",
    transform: "translate(-10 -7.054)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105868",
    "data-name": "Path 105868",
    d: "M28.085,26.55,22.9,21.365v-.379L28.085,15.8l.126.126,6.2,3.541c1.771,1.012,1.771,2.656,0,3.668Z",
    transform: "translate(-6.585 -4.857)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105869",
    "data-name": "Path 105869",
    d: "M31.521,25.312,26.209,20,10.4,35.809c.632.632,1.518.632,2.656.126L31.521,25.312",
    transform: "translate(-9.894 -3.745)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105870",
    "data-name": "Path 105870",
    d: "M31.521,18.084,13.056,7.587a2.05,2.05,0,0,0-2.656.126L26.209,23.4l5.312-5.312Z",
    transform: "translate(-9.894 -7.141)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105871",
    "data-name": "Path 105871",
    d: "M31.394,24.1,13.056,34.471a2.068,2.068,0,0,1-2.529,0L10.4,34.6l.126.126a2.068,2.068,0,0,0,2.529,0Z",
    transform: "translate(-9.894 -2.66)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105872",
    "data-name": "Path 105872",
    d: "M10.506,35.556A2.473,2.473,0,0,1,10,33.785v.126a2.5,2.5,0,0,0,.632,1.771v-.126h-.126ZM37.824,21.644,31.5,25.185l.126.126,6.2-3.541A2.1,2.1,0,0,0,39.088,20C39.088,20.632,38.583,21.138,37.824,21.644Z",
    transform: "translate(-10 -3.745)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105873",
    "data-name": "Path 105873",
    d: "M13.162,7.72,37.824,21.758c.759.506,1.265,1.012,1.265,1.644a2.1,2.1,0,0,0-1.265-1.771L13.162,7.593C11.391,6.582,10,7.34,10,9.364V9.49C10,7.593,11.391,6.708,13.162,7.72Z",
    transform: "translate(-10 -7.147)",
    fill: "#fff",
    opacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleStore);
export default __webpack_public_path__ + "static/media/google-store.6cb8b96fb3e3e67dac9a3ff86e46214a.svg";
export { ForwardRef as ReactComponent };